// userSelectors.js

export const selectPatientDetails = (state) => state.familyTree.patientDetails;
export const selectLoading = (state) => state.familyTree.loading;
export const selectFamilyTreeDetails = (state) => state.familyTree.familyTreeDetails;
export const selectCountryDetails = (state) => state.familyTree.countryDetails;
export const selectSuccessfullyFamilyAdded = (state) => state.familyTree.successMessage;
export const selectFamilyTreeState = (state) => state.familyTree;
